var subscribe = require('../api/subscribe')
var unsubscribe = require('../api/unsubscribe')
var getUA = require('../../common/get-ua')
var mixin = require('../../common/mixin')
var noop = function () {}
var getNetworkType = require('../api/get-network')
var share = require('../api/share')
var qs = require('querystring')
var isWebProtocol = require('../../common/web-protocol')
var picConverter = require('../../common/picConverter');
var semver = require('../../common/semver');
var UA = getUA.internal();
var win = typeof window !== 'undefined' ? window : {};
var Promise = win.Promise || require('pinkie');
var useStorageV2 = semver.gte(UA.titansxVersion, '11.8.0');
var canUseStatusBar = semver.gte(UA.titansxVersion, '11.18.7') || (UA.osName === 'ios');


function prependBizName (key, fail) {
  var bizName = this.getBizName()
	if (key.indexOf(':') > -1) return key
	if (bizName) return bizName + ':' + key
	this.log('bizname not configed')
	fail('bizname not config, please call KNB.confg({bizName: YOUR_BIZ_NAME})')
}

var localScheme = {
  'meituan': 'imeituan://www.meituan.com/web',
  'dianping': 'dianping://web'
}

var serviceMap = {
  'voip': 'com.meituan.android.customerservice.utils',
  'payment': 'com.meituan.android.paycommon.lib',
}

function getWebViewInfo() {
  var this$1 = this;

  return new Promise(function (resolve) {
    var scheme = 'dianping://web', urlKey = 'url';
    if (window.TITANS_WEB_VIEW_URI) return resolve({scheme: window.TITANS_WEB_VIEW_URI, urlKey: urlKey});
    this$1.getAppInfo({
      success: function(result) {
        var scheme = result.scheme; if ( scheme === void 0 ) scheme = '';
        var matches = scheme.match(/(.*)\?(.*)/);
        if (matches) {
          resolve({scheme: matches[1] || localScheme[UA.appName] || scheme, urlKey: matches[2] || urlKey});
        } else {
          resolve({scheme: localScheme[UA.appName] || scheme, urlKey: urlKey});
        }
      },
      fail: function() {
        resolve({scheme: localScheme[UA.appName] || scheme, urlKey: urlKey});
      }
    })
  });
}

function concatSchemeURL(scheme, urlKey, url, query) {
  var urlObject = {};
  urlObject[urlKey] = url;
  return (scheme + "?" + (qs.stringify(mixin(urlObject, query))));
}

module.exports = [
  {
    message: 'checkVersion',
    mapper: function(options) {
      console.warn('checkVersion、getApisVersion、isApiSupported 接口已停止维护，详情请联系 rencheng');
      return options
    }
  },{
    message: 'getApisVersion',
    handler: function(ref) {
      var success = ref.success; if ( success === void 0 ) success = noop;
      var apis = ref.apis; if ( apis === void 0 ) apis = [];
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      this.checkVersion({
        apis: apis,
        success: function (data) {
          if (data.infos === null) {
            success(apis.map(function () { return '1.0'; }));
          } else {
            var infos = {};
            if (typeof data.data === 'object') infos = data.data.infos || {};
            if (typeof data.infos === 'object') infos = data.infos;
            success(apis.map(function (api) {
              return String(infos[api] || '1.0');
            }));
          }
        },
        fail: fail
      });
    }
  },{
    message: 'actionSheet',
    mapper: function(options) {
      console.warn('actionSheet 接口已停止维护，详情请联系 rencheng');
      return options
    }
  }, {
    message: 'alert',
    mapper: function(options) {
      console.warn('alert 接口已停止维护，详情请联系 rencheng');
      return options
    }
  }, {
    name: 'closeWebview',
    message: 'closeWindow'
  }, {
    message: 'getContactList'
  }, {
    name: 'getUA',
    handler: getUA
  }, {
    message: 'confirm',
    mapper: function(options) {
      console.warn('confirm 接口已停止维护，详情请联系 rencheng');
      return options
    }
  }, {
    message: 'getVersion'
  }, {
    message: 'isInstalledApp'
  }, {
    message: 'pickContact'
  }, {
    message: 'prompt',
    mapper: function(options) {
      console.warn('prompt 接口已停止维护，详情请联系 rencheng');
      return options
    }
  }, {
    message: 'publish',
    mapper: function (ref) {
      var type = ref.type;
      var level = ref.level;
      var action = ref.action;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
      var data = ref.data;
      var info = ref.info;

      //fix mtnb 实现bug(for attribute data && info);
      if (type === 'native') return {level: level, action: action, success: success, fail: fail, data: info || data}
      var actionName = prependBizName.call(this, action, fail)
      if (actionName) return {level: level, action: actionName, success: success, fail: fail, data: info || data}
    }
  }, {
    message: 'remove',
    mapper: function (ref) {
      var type = ref.type;
      var key = ref.key;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      var newkey;
      if (type === 'native') {
        newkey=key;
      } else {
        newkey = prependBizName.call(this, key, fail)
      }
      if (!newkey) return;
      if (useStorageV2) {
        console.warn('remove 桥已停止维护，请使用 clearStorage 桥替换，详情可联系 rencheng');
        this.clearStorage({key: newkey, success: success, fail: fail});
        return;
      }
      return {key: newkey, success: success, fail: fail}
    }
  }, {
    message: 'retrieve',
    mapper: function (ref) {
      var type = ref.type;
      var key = ref.key;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      var newkey;
      if (type === 'native') {
        newkey=key;
      } else {
        newkey = prependBizName.call(this, key, fail)
      }
      if (!newkey) return;
      if (useStorageV2) {
        console.warn('retrieve 桥已停止维护，请使用 getStorage 桥替换，详情可联系 rencheng');
        this.getStorage({key: newkey, success: success, fail: fail});
        return;
      }
      return {key: newkey, success: success, fail: fail};
    }
  }, {
    message: 'store',
    mapper: function (ref) {
      var type = ref.type;
      var key = ref.key;
      var value = ref.value;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      var newkey;
      if (type === 'native') {
        newkey=key;
      } else {
        newkey = prependBizName.call(this, key, fail)
      }
      if (!newkey) return;
      if (useStorageV2) {
        console.warn('store 桥已停止维护，请使用 setStorage 桥替换，详情可联系 rencheng');
        this.setStorage({key: newkey, value: value, level: 1,success: success, fail: fail});
        return;
      }
      return {key: newkey, value: value,success: success, fail: fail}
    }
  }, {
    message: 'setLLButton'
  }, {
    message: 'setLRButton'
  }, {
    message: 'setRLButton'
  }, {
    message: 'setRRButton'
  }, {
    message: 'setTitle',
    mapper: function (options) {
      console.warn('setTitle 桥已停止维护，请使用 document.title 方法设置替换，详情可联系 rencheng');
      return options;
    }
  }, {
    message: 'sendSMS'
  }, {
    message: 'setBackgroundColor'
  }, {
    message: 'setNavigationBarHidden',
    os: 'android'
  }, {
    message: 'setBouncesEnabled',
    os: 'ios'
  }, {
    message: 'setScrollEnabled',
    os: 'ios'
  }, {
    message: 'setStatusBarStyle',
    mapper: function (_opts) {
      if (canUseStatusBar) {
        // Android 11.18.7 以上版本支持这个接口，同时在 Android 11.15.x - 11.16.x 版本有不返回 fail 回调的 BUG，所以这里一定得主动添加 fail 回调
        var fail = _opts.fail || noop;
        return fail({ status: 'fail', result: 'next', errorCode: -404 });
      }
      var opts = mixin({}, _opts)
      if (opts.style === undefined) opts.style = 0
      return opts
    }
  }, {
    name: 'setNavButtons',
    handler: function (opts) {
      var this$1 = this;

      [].concat(opts).forEach(function (btnConfig) {
        var nobj = mixin({}, btnConfig) // create a copy
        delete nobj.position
        nobj.icon = btnConfig.type === 'base64' ? (btnConfig.icon || '').split('data:image/png;base64,')[1] : nobj.icon
        this$1['set' + btnConfig.position + 'Button'](nobj)
      })
    }
  }, {
    message: 'bind'
  }, {
    message: 'chooseImage',
    mapper: function (options) {
      if ( options === void 0 ) options = {};

      options.quality = options.quality || 50;
      options.type = options.source || options.type;
      return options;
    }
  }, {
    message: 'downloadImage',
    mapper: function(options) {
      console.warn('downloadImage接口已停止维护，详情请联系 rencheng');
      return options;
    }
  }, {
    name: 'getCity',
    message: 'getCityInfo'
  }, {
    message: 'getUserInfo',
    mapper: function (opt) {
      return mixin({}, opt, {
        success: function (result) { return opt.success(mixin(result, {
          token: result.token || result.userToken,
          uuid: result.uuid || result.unionId
        })); }
      });
    }
  }, {
    message: 'getFingerprint'
  }, {
    message: 'getLocation',
    mapper: function (opts) {
      if (!opts.timeout) {
        opts.timeout = 6000;
      }
      return opts;
    }
  }, {
    // @deprecated
    name: 'getLocationCity',
    message: 'getCityInfo',
    mapper: function (opt) {
      console.warn('getLocationCity 桥已停止维护，请使用 getCity 桥替换，详情可联系 rencheng');
      return mixin({}, opt, {
        success: function (cityInfo) { return opt.success(mixin(cityInfo, {cityId: cityInfo.locCityId, cityName: cityInfo.locCityName})); }
      });
    }
  }, {
    // @dp
    name: 'getCX',
    message: 'getFingerprint'
  }, {
    message: 'analyticsTag',
    version: '8.1.6'
  }, {
    name: 'jumpWebview',
    message: 'jumpToScheme',
    mapper: function (opts) {
      var this$1 = this;

      if (isWebProtocol(opts.url)) {
        getWebViewInfo.call(this).then(function (result) {
          var scheme = result.scheme;
          var urlKey = result.urlKey;
          var url = opts.url;
          var qs = opts.qs; if ( qs === void 0 ) qs = {};
          var query = opts.query; if ( query === void 0 ) query = {};
          var urlQuery = mixin({}, qs, query);
          opts.url = concatSchemeURL(scheme, urlKey, url, urlQuery);
          this$1.jumpWebview(opts);
        })
        return 0;
      }
      opts.qs = undefined;
      opts.query = undefined;
      console.warn('jumpWebview 接口已停止维护，建议切换 jumpPage 桥，详情请联系 rencheng');
      return opts;
    }
  }, {
    name: 'openWebview',
    message: 'openScheme',
    mapper: function (opts) {
      var this$1 = this;

      if (isWebProtocol(opts.url)) {
        getWebViewInfo.call(this).then(function (result) {
          var scheme = result.scheme;
          var urlKey = result.urlKey;
          var url = opts.url;
          var qs = opts.qs; if ( qs === void 0 ) qs = {};
          var query = opts.query; if ( query === void 0 ) query = {};
          var urlQuery = mixin({}, qs, query);
          opts.url = concatSchemeURL(scheme, urlKey, url, urlQuery);
          this$1.openWebview(opts);
        })
        return 0;
      }
      opts.qs = undefined;
      opts.query = undefined;
      console.warn('openWebview 接口已停止维护，建议切换 openPage 桥，详情请联系 rencheng');
      return opts;
    }
  }, {
    name: 'openPage',
    message: 'openScheme',
    mapper: function (opts) {
      var this$1 = this;

      if (isWebProtocol(opts.url)) {
        getWebViewInfo.call(this).then(function (result) {
          var scheme = result.scheme;
          var urlKey = result.urlKey;
          var url = opts.url;
          var qs = opts.qs; if ( qs === void 0 ) qs = {};
          var query = opts.query; if ( query === void 0 ) query = {};
          var urlQuery = mixin({}, qs, query);
          opts.url = concatSchemeURL(scheme, urlKey, url, urlQuery);
          this$1.openPage(opts);
        })
        return 0;
      }
      opts.qs = undefined;
      opts.query = undefined;
      return opts;
    }
  }, {
    name: 'jumpPage',
    message: 'jumpToScheme',
    mapper: function (opts) {
      var this$1 = this;

      if (isWebProtocol(opts.url)) {
        getWebViewInfo.call(this).then(function (result) {
          var scheme = result.scheme;
          var urlKey = result.urlKey;
          var url = opts.url;
          var qs = opts.qs; if ( qs === void 0 ) qs = {};
          var query = opts.query; if ( query === void 0 ) query = {};
          var urlQuery = mixin({}, qs, query);
          opts.url = concatSchemeURL(scheme, urlKey, url, urlQuery);
          this$1.jumpPage(opts);
        })
        return 0;
      }
      opts.qs = undefined;
      opts.query = undefined;
      return opts;
    }
  }, {
    name: 'closePage',
    message: 'closeWindow'
  }, {
    name: 'configShare',
    handler: function (opts) {
      var this$1 = this;

      opts = mixin({}, opts)
      var handle = opts.handle || noop
      delete opts.handle
      this.setRRButton({
        icon: 'H5_Share',
        handle: function () {
          handle()
          this$1.share(opts)
        }
      })
    }
  }, {
    message: 'pickCity',
    statics: {
      INLAND: 0,
      FOREIGN: 1,
      ALL: 2
    }
  }, {
    message: 'analyticsTag'
  }, {
    message: 'setBarrageEnabled'
  }, {
    message: 'getHealthData',
    os: 'ios',
    mapper: function (_opts) {
      if (!_opts) return
      var opts = mixin({}, _opts)
      // 目前支持的类型
      var typeList = [1]
      var type = opts.quantityType
      var fail = opts.fail || noop

      var start = +new Date(opts.startDate)
      var end = +new Date(opts.endDate || new Date())
      if (start > end) { fail('date error'); return; }
      if (typeList.indexOf(type) === -1) { fail('type error'); return; }
      // 单位：秒
      opts.startDate = Math.round(start / 1000)
      opts.endDate = Math.round(end / 1000)
      return opts
    }
  }, {
    name: 'ajax',
    message: 'mapi',
    mapper: function (_opts) {
      console.warn('ajax、mapi接口已停止维护，详情请联系 rencheng');
      var opts = mixin({}, _opts)
      var self = this;
      opts = this.util.sanitizeAjaxOpts(opts)
      var success = opts.success || noop;
      opts.success = function (ret) {
        var result = JSON.parse(ret.mapiResult)
        result = self.util.transModel(opts.keys, result)
        success(result)
      };
      return opts
    }
  }, {
    message: 'login',
    mapper: function (opts) {
      var success = opts.success || noop
      // 新版Titans增加type字段标识用户类型
      return mixin({}, opts, {
        success: function (res) {
          success(mixin({}, res, res.dpid ? {type: 'dp'} : {}, {token: res.token || res.userToken}))
        }
      })
    }
  }, {
    message: 'logout'
  }, {
    message: 'pay'
  }, {
    message: 'playVoice'
  }, {
    message: 'previewImage'
  }, {
    message: 'setPullDown'
  }, {
    message: 'stopPullDown'
  }, {
    message: 'setNavigationBarHidden',
    os: 'ios'
  }, {
    message: 'uploadPhoto',
    name: 'uploadImage',
    mapper: function (_opts) {
      var opts = mixin({}, _opts);
      var success = opts.success || noop;

      if (!opts.bucket) {
        opts.bucket = opts.clientId = 'knb';
      } else if (!opts.clientId) {
        opts.clientId = opts.bucket;
      }

      opts.success = function (result) {
        result.photoInfos = (result.photoInfos || result.ret || []).map(function (photo) {
          var picKey = picConverter(photo.picKey);
          var picUrl = picConverter(photo.picUrl);
          return mixin({}, photo, {
            picKey: picUrl,
            originalKey: photo.picKey,

            //对齐点评picKey和picUrl的语义
            picUrl: picUrl || (/^https?:\/\//.test(picKey) ? picKey : null),
            originalUrl: photo.picKey || photo.picUrl
          })
        });
        success(result);
      }

      return opts;
    }
  }, {
    message: 'vibrate'
  }, {
    message: 'toast'
  }, {
    message: 'autoLock'
  }, {
    message: 'lxlog',
    mapper: function(options){
      console.warn('KNB.lxlog接口已停止维护，详情请联系 rencheng');
      return options;
    }
  }, {
    message: 'Semver',
    statics: semver
  }, {
    message: 'checkAuthorization'
  }, {
    message: 'capture'
  }, {
    message: 'shareImage',
    statics: {
      WECHAT_FRIENDS: 0,
      WECHAT_TIMELINE: 1
    }
  }, {
    message: 'setSearchBar',
    mapper: function(options) {
      console.warn('setSearchBar接口已停止维护，详情请联系 rencheng');
      return options;
    }
  }, {
    message: 'scanQRCode'
  }, {
    message: 'setResult',
    statics: {
      "RESULT_OK": -1,
      "RESULT_CANCELED": 0
    }
  }, {
    //mt 8.5
    message: 'getResult',
    mapper: function(opts){
      var originSuccess = opts.success || noop;
      return mixin({}, opts, {
        success: function (res) {
          originSuccess(mixin({}, {
            resultData: res.resp ? res.resp.resultData : res.resultData,
            resultCode: res.resp ? res.resp.resultCode : res.resultCode
          }));
        }
      }) 
    }
  }, { 
    //mt 8.5
    message: 'setImageTitle',
    mapper: function(options) {
      console.warn('setImageTitle接口已停止维护，详情请联系 rencheng');
      return options;
    }
  }, {
    message: 'shark',
    mapper: function(options) {
      console.warn('shark接口已停止维护，详情请联系 rencheng')
      return options;
    }
  }, {
    message: 'chooseMedia',
  }, {
    message: 'playMedia'
  }, {
    message: 'editMedia'
  }, {
    message: 'uploadMedia'
  }, {
    message: 'getDeviceInfo'
  }, {
    message: 'showKeyboard',
    os: 'android'
  }, {
    message: 'sendLog',
    mapper: function(opts){
      return mixin({}, opts, {
        time: +new Date(),
        page: location.href
      });
    }
  }, {
    message: 'shareMiniProgram'
  }, {
    message: 'addRequestSignature',
    mapper: function(ref){
      var method = ref.method;
      var url = ref.url;
      var body = ref.body; if ( body === void 0 ) body = "";
      var header = ref.header; if ( header === void 0 ) header = {};
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      var contentType = header.contentType; if ( contentType === void 0 ) contentType = "";
      var contentEncoding = header.contentEncoding; if ( contentEncoding === void 0 ) contentEncoding = "";
      var originSuccess = success;
      var userAgent = navigator.userAgent || "";
      return {
        method: method, 
        url: url, 
        body: body, 
        header:{contentType: contentType, userAgent: userAgent, contentEncoding: contentEncoding},
        success: function (res) {
          var url = res.url || '';
          if(url.indexOf('://') === -1){
            res.url = decodeURIComponent(url);
          }
          originSuccess(res);
        }, 
        fail: fail
      };
    }
  }, {
    message: 'stopLocating'
  }, {
    message: 'setStorage',
    mapper: function(options) {
      if(useStorageV2) {
        return options;
      }
      this.store(mixin({}, options, {type: 'native'}));
    }
  }, {
    message: 'getStorage',
    mapper: function(options) {
      if(useStorageV2) {
        return options;
      }
      this.retrieve(mixin({}, options, {type: 'native'}));
    }
  }, {
    message: 'clearStorage',
    mapper: function(options) {
      if(useStorageV2) {
        return options;
      }
      this.remove(mixin({}, options, {type: 'native'}));
    }
  }, {
    message: 'getAppInfo'
  }, {
    message: 'getWifiInfo'
  }, {
    message: 'getImageInfo'
  }, {
    message: 'getMediaFrame'
  }, {
    message: 'installApp'
  }, {
    message: 'setTitleBar'
  }, {
    message: 'resetTitleBar'
  }, {
    message: 'setTitleBarAction'
  }, {
    message: 'addTitleBarElement'
  }, {
    message: 'removeTitleBarElement'
  }, {
    message: 'replaceTitleBarElement'
  }, {
    message: 'setupEvent'
  }, {
    message: 'openMiniProgram'
  }, {
    message: 'enableSlideBack'
  }, {
    message: 'openPageForResult',
    handler: function(options) {
      var this$1 = this;
      if ( options === void 0 ) options = {};

      var url = options.url;
      var qs = options.qs;
      var success = options.success; if ( success === void 0 ) success = noop;
      var _fail = options.fail; if ( _fail === void 0 ) _fail = noop;
      var subId;
      this.subscribe({
        action:'appear',
        handle: function () {
          this$1.unsubscribe({
            subId: subId,
            fail: function () { return console.warn('the subscribe is still exsit'); }
          });
          this$1.getResult({
            success: success,
            fail: function () { return _fail({errorCode: -500, errorMsg: 'there is not any data for you'}); }
          });
        },
        success: function (result) {
          subId = result.subId;
          this$1.openWebview({
            url: url,
            qs: qs,
            fail: function () { return _fail({errorCode: -500, errorMsg: 'openWebview wrong'}); }
          })
        },
        fail: function () { return _fail({errorCode: -500, errorMsg: 'subscribe appear wrong'}); }
      })
    }
  }, {
    message: 'requestPermission'
  }, {
    message: 'getServiceInfo',
    mapper: function(params) {
      var name = params.name;
      var success = params.success;
      var fail = params.fail; if ( fail === void 0 ) fail = noop;
      var serviceName = (name + '').toLowerCase();
      if (Object.keys(serviceMap).indexOf(serviceName) === -1) {
        fail({errorCode: -401, errorMsg: 'service not supported'});
        return;
      } else if(UA.osName === 'android') {
        serviceName = serviceMap[serviceName];  
      }
      return { name: serviceName, success: success, fail: fail };
    }
  }, {
    message: 'getPageState'
  }, {
    message: 'sendEvent',
    mapper: function(params) {
      var frame = params.frame;
      var fail = params.fail; if ( fail === void 0 ) fail = noop;
      if (!frame) {
        fail({errorCode: -401, errorMsg: 'frame should not be \'\''});
        return;
      }
      return params;
    }
  }
].concat([subscribe, unsubscribe, getNetworkType, share])
